import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--color-gray-600)",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1 21c0-1.323-.011-2.206.215-2.951a5 5 0 0 1 3.334-3.334c.745-.226 1.628-.215 2.951-.215H13a1 1 0 1 1 0 2H7.5c-1.468 0-1.981.01-2.371.129a3 3 0 0 0-2 2C3.01 19.019 3 19.532 3 21a1 1 0 1 1-2 0M13.5 7.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0m2 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" }, null, -1),
    _createElementVNode("path", { d: "M21 17.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0m2 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" }, null, -1),
    _createElementVNode("path", { d: "M18.317 15.769a1 1 0 0 1 1.366 1.462l-2.144 2a1 1 0 0 1-1.364 0l-.858-.8a1 1 0 0 1 1.366-1.462l.173.162z" }, null, -1)
  ]))]))
}
export default { render: render }